import { render } from "./Control.vue?vue&type=template&id=2a3285fa&scoped=true"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"

import "./Control.vue?vue&type=style&index=0&id=2a3285fa&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3285fa"]])

export default __exports__